import React from "react";
import { View } from "react-native";
import { PALETTE } from "../lib/palette";

/**
 * CSS 테두리로 그린 방향 셰브론(폰트 무관 → 전 플랫폼에서 좌우/상하 대칭 중앙정렬).
 * Ionicons chevron 글리프가 브라우저마다 좌우로 치우쳐 보이던 문제를 근본 제거한다.
 * 원리: 우·하 테두리만 있는 정사각형을 방향별 각도로 회전(회전축=중심이라 대칭).
 */
export function Chevron({
  direction = "down",
  size = 10,
  thickness = 2,
  color = PALETTE.MUTED,
  style,
}: {
  direction?: "down" | "up" | "left" | "right";
  size?: number;
  thickness?: number;
  color?: string;
  style?: any;
}) {
  const rot = { down: "45deg", up: "-135deg", left: "135deg", right: "-45deg" }[direction];
  // 광학 보정: 회전 사각형의 잉크가 꼭짓점(=direction) 쪽으로 쏠려 보이므로 반대쪽 음수 마진으로 되민다.
  const k = Math.round(size / 3);
  const nudge = {
    down: { marginTop: -k },
    up: { marginBottom: -k },
    left: { marginRight: -k },
    right: { marginLeft: -k },
  }[direction];
  return (
    <View
      style={[
        {
          width: size,
          height: size,
          borderRightWidth: thickness,
          borderBottomWidth: thickness,
          borderColor: color,
          transform: [{ rotate: rot }],
        },
        nudge,
        style,
      ]}
    />
  );
}
